/// <reference path="./EntryItem.ts" />
namespace HA.Core.HTML {
    import EntryItem = HA.Core.HTML.HAList.EntryItem;

    export interface IListItemEntry {
        getId(): string;
    }

    export class List extends Container {

        public setModel(model: Map<string, any>) {
            if (!(model instanceof Map)) {
                model = toMap(model);
            }
            if (!model.get("list")) {
                model = toMap({list: toMap({ default: model})});
            }
            if (!(model.get("list") instanceof Map)) {
                model.set("list", toMap(model.get("list")));
            }
            this.addToData("model", toMap(model));
            this.addToData("mod", "m");
            if (!this.has("entryClass")) {
                this.addToData("entryClass", EntryItem);
            }
        }

        public setItemClick(func: () => void) {
            this.addToData("itemClick", func);
        }

        public addAllByModel(data: []) {
            const me = this;
            data.forEach((d: any) => {
                me.addByModel(d);
            });
        }

        public addByModel(data: Map<string, any>) {
            if (this.has("nowrap")) {
                const m = toMap(this.getModel(data.get("_model")));
                m.set("trans", data.get("trans"));
                this.addItem(new Tag(m));
                return;
            }
            data.set("model", toMap(this.getModel(data.get("_model"))));
            this.addItem(data);
        }

        public getModel(name?: string) {
            const m: Map<any, any> = this.get("model");

            if (!m.has("list")) {
                return m;
            }

            const list: Map<any, any> = m.get("list");

            if (name && list.get(name)) {
                return list.get(name);
            }

            return list.get("default");
        }

        public replaceItems(items: any[]) {
            this.clear();
            this.addToData("items", new Map());
            const me = this;
            items.forEach((e: any) => {
                me.addItem(e);
            });
        }

        /**
         *
         * @returns {Array}
         */
        public hasValue(v: any) {
            let r = false;
            this.getItems().forEach((i: IListItem) => {
                if (i.getValue() === v) {
                    r = true;
                    return;
                }
            });

            return r;
        }

        public getFirst(): Tag {
            const items: Tag[] = this.getItems();
            let i2: Tag;
            items.forEach((i: Tag, id: any) => {
                if (!i2) {
                    i2 = i;
                    return;
                }
            });
            return i2;
        }

        public removeFirst(): Tag {
            const item = this.getFirst();
            if (item) {
                const el: Element = this.getElement();
                if (el.firstChild) {
                    el.removeChild(el.firstChild);
                }
                this.getItems().delete(item.getId());
                return item;
            }

            return null;
        }

        /**
         *
         * @returns {Array}
         */
        public getValues() {
            const r = [];
            this.getItems().forEach((i: IListItem) => {
                r.push(i.getValue());
            });

            return r;
        }

        /**
         *
         * @param items
         * @param noAppend
         */
        public addItems(items: any, noAppend?: boolean) {
            const me = this;
            items.forEach((data: any) => {
                me.addItem(data, noAppend);
            });
        }

        /**
         *
         * @param item
         * @param noAppend
         */
        public addItem(item: any, noAppend?: boolean) {
            const entry: IListItemEntry = this.toEntry(item);
            this.getItems().set(entry.getId(), entry);
            if (!noAppend) {
                this.appendChild(entry);
            }
        }

        /**
         *
         * @returns {Map}
         */
        public getItems() {
            if (this.hasNot("items")) {
                this.addToData("items", new Map());
            }

            return this.get("items");
        }

        protected initialize(data: any): void {
            super.initialize(data);
            const me = this;
            const c = this.getChildren();
            const itemTagClass = this.get("itemTagClass");

            if (this.has("m")) {
                this.setModel(this.translate(this.get("m")));
            }
            c.forEach((tag: Tag) => {
                if (itemTagClass) {
                    me.addItem(new itemTagClass(tag), true);
                } else {
                    me.addItem(tag, true);
                }
            });

            if (this.has("d")) {
                const items = toMap(this.translate(this.get("d")));
                if (items) {
                    items.forEach((i: any) => {
                        me.addByModel(toMap(i));
                    });
                }
            }
        }

        protected toEntry(tag: any | Tag): IListItemEntry | any {
            if (this.has("entryClass") && !(tag instanceof this.get("entryClass"))) {
                const c = this.get("entryClass");
                const tag2 = new c(tag);
                if (this.has("itemClick")) {
                    const t2 = toMap(tag.get("trans")).get("cd");
                    tag2.onClick(() => {
                        this.get("itemClick")(t2)
                    });
                }
                tag = tag2;
            }

            if (!tag.getId()) {
                tag.setId(Math.random() * 1000000);
            }

            return tag;
        }
    }
}
